import SiteIndex from '@/site-index/SiteIndex.vue'
import {registerRoute} from '@/router'

export const INDEX = {componentName: 'Index', component: SiteIndex, meta: {requiresOrg: true}}

registerRoute(INDEX)